import {StorageDAO} from './../DAO/StorageDAO';
import {toCamel} from '../Util/SnakeCamelUtil';
import {BaseService} from './BaseService';
import {PcrDAO} from '../DAO/PcrDAO';
import {AppSingletonUtil} from '../Util/AppSingletonUtil';
import {AppSettingApi} from '../AppSettingApi';
import {lastValueFrom} from 'rxjs';

/**
 * PcrService
 *
 * PCR検査系サービス
 * DAOで取得したデータを操作等行い、View側に渡す。
 */
export class PcrService extends BaseService {

	/**
	 * 検体情報の取得
	 * @param id 検体テーブルID
	 * @param specNum 検体番号
	 */
	public async getSpecimen(id?: number, specNum?: number) {

		// httpクライアントの取得
		const http = AppSingletonUtil.getHttpClient();

		// リクエスト
		const request = {
			t: AppSingletonUtil.getToken(),
			id,
			spec_num: specNum
		};

		const response = http.post(AppSettingApi.PCR_SPECIMEN_GET, request)
		const ret = <{body: Object, code: string, message: string}>await lastValueFrom(response);

		return toCamel(ret.body)

	}

	/**
	 * getUserInfo
	 * ユーザー情報の取得
	 * @returns ユーザー情報
	 */
	public async getPcrInterviewMstList() {

		// 問診票を取得する
		const dao = new PcrDAO(this as BaseService);
		const ret = await dao.getPcrInterviewMst();
		const dist = this.obj2Array(toCamel(ret));

		dist.map(item => {
			item.answer = this.obj2Array(item.answer);
		});
		const country = this.obj2Array(dist.pop());
		dist['country'] = country;

		return dist;

	}

	/**
	 * savePcrInterview
	 * 問診登録
	 * @param data 問診データ
	 * @param specimenNum 検体番号
	 * @param pcrExamineRemark 備考
	 */
	public async savePcrInterview(data: any, specimenNum: number, pcrExamineRemark: string) {
		// 問診を保存する
		const dao = new PcrDAO(this as BaseService);
		const ret = await dao.savePcrUserInterview(data.cert, data.positiveCert, data.type, data.group, data.express,
			data.name, data.passportNo, data.nationality, data.date, specimenNum, pcrExamineRemark);

		return this.obj2Array(toCamel(ret));
	}

	public async getStoredSpecimenNum() {

		const dao = new StorageDAO(this as BaseService);

		// 存在チェック
		const isExist = await dao.isItemExist('spn');
		if (!isExist) {return null;}


		const ret = await dao.getItem('spn');
		return ret;

	}

	public async saveSpecimenNumToStorage(specimenNum: string) {

		const dao = new StorageDAO(this as BaseService);
		const ret = await dao.saveItem('spn', specimenNum);

	}

	//　保存された検体番号の削除
	public async deleteSpecimenNumToStorage() {

		const dao = new StorageDAO(this as BaseService);
		const ret = await dao.deleteItem('spn');

	}

	public async isExistSpecimenNum() {

		const dao = new StorageDAO(this as BaseService);
		const ret = await dao.isItemExist('spn');

		return ret;

	}


}
